G.BoardCandy = G.BoardCandy || {};

G.BoardCandy.InfectionType = function() {
  G.BoardCandy.CandyType.call(this);
};

G.BoardCandy.InfectionType.prototype = Object.create(G.BoardCandy.CandyType.prototype);

G.BoardCandy.InfectionType.prototype.onHit = function() {
  G.sb("fxTop").dispatch('burstInfectionAnim', this.candy, this.candy);
  this.signals.removeCandy.dispatch();
};